import React from "react";
export const PurpleThing7 = () => (
  <svg className="purple-thing7" version="1.2" viewBox="0 0 9 9" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4.39" cy="4.31" r="3.96" fill="var(--main-light)"/>
  </svg>
);
export default PurpleThing7;